export default __webpack_public_path__ + "static/media/guide35.4810345d.png";